// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__35ABF","default":"TextArea_default__1TPcc","note":"TextArea_note__2MgbU","note-video":"TextArea_note-video__2KVxP"};